import { create } from 'zustand'
import type { User } from '../types'

interface AuthStore {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  setAuth: (user: User, token: string) => void
  logout: () => void
  updateUser: (user: User) => void
}

const storedUser = (): User | null => {
  try {
    const raw = localStorage.getItem('pm_user')
    return raw ? (JSON.parse(raw) as User) : null
  } catch {
    return null
  }
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: storedUser(),
  token: localStorage.getItem('pm_token'),
  isAuthenticated: !!localStorage.getItem('pm_token'),

  setAuth: (user: User, token: string) => {
    localStorage.setItem('pm_token', token)
    localStorage.setItem('pm_user', JSON.stringify(user))
    set({ user, token, isAuthenticated: true })
  },

  logout: () => {
    localStorage.removeItem('pm_token')
    localStorage.removeItem('pm_user')
    set({ user: null, token: null, isAuthenticated: false })
  },

  updateUser: (user: User) => {
    localStorage.setItem('pm_user', JSON.stringify(user))
    set({ user })
  },
}))
